<template>
  <el-dialog
    class="aftersale-edit-dialog"
    :title="serviceNo"
    width="30%"
    :append-to-body="true"
    :visible.sync="editDialogVisible"
  >
    <el-form :model="goodsEditform">
      <el-form-item label="SKU:829030"></el-form-item>
      <el-form-item
        v-show="showInbound"
        label="入库数量:"
        label-width="80px"
      >
        <el-input
          v-model="goodsEditform.name"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-show="!showInbound"
        label="出库数量:"
        label-width="80px"
      >
        <el-input
          v-model="goodsEditform.name"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-show="!showInbound"
        label="快递单号:"
        label-width="80px"
      >
        <el-input
          v-model="goodsEditform.name"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="editDialogVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="editDialogVisible = false"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['boxData'],
  data () {
    return {
      showInbound: true,
      goodsEditform: {},
      serviceNo: 'AS2783028303',
      editDialogVisible: false
    }
  },
  methods: {}
}
</script>
<style lang="scss">
.aftersale-edit-dialog {
  .el-dialog {
    max-width: 360px;
    min-width: 336px;
    .el-dialog__footer {
      margin-top: -30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bigAftersale/aftersale-edit-dialog.vue